import { config } from '@mybonus/public';
import { useAccountContext, useAPI, useAuthContext, useMutation, useQuery } from '@mybonus/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const routePath = '/offers';

export function useMychipsView() {
	const { api } = useAPI();
	const auth = useAuthContext();
	const account = useAccountContext();
	const navigate = useNavigate();

	const availability = useQuery(
		'user.mychips.availability',
		(args) => api.user.mychips.availability.query(args),
		undefined,
		{
			ttl: false,
			refreshFromClient: !!auth.account,
		},
	);

	const launch = useMutation<void>(() => api.user.mychips.webLaunch.mutate());
	const launchData = launch.data as { iframeUrl: string } | undefined;

	function handleIdentified() {
		launch.reset();
		account.invalidate();
		availability.load({ bypassCache: true, refetch: true });
	}

	function handleRetry() {
		launch.reset();
		launch.mutate();
	}

	useEffect(() => {
		if (
			availability.data?.status === 'LOGIN_REQUIRED' &&
			!auth.isLoading &&
			!auth.account &&
			!availability.isLoading
		) {
			navigate(config.urls.login({ redirectBackToPath: routePath }));
		}
	}, [availability.data?.status, navigate, auth.isLoading, auth.account, availability.isLoading]);

	useEffect(() => {
		if (
			availability.data?.status === 'READY' &&
			!launch.data &&
			!launch.isLoading &&
			!launch.error
		) {
			launch.mutate();
		}
	}, [availability.data?.status, launch.data, launch.error, launch.isLoading]);

	return {
		availability,
		launch,
		launchData,
		handleIdentified,
		handleRetry,
	};
}
